<template>
  <div>
    <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/partManagement/addpartManagement')"
    >
      新增
    </a-button>
    <a-button type="danger" :style="{ margin: '0 0 24px 0' }" @click="dels">
      批量删除
    </a-button>
    <a-table
      :columns="columns"
      :row-key="(record) => record.id"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-selection="rowSelection"
    >
      <template slot="surfacePlot" slot-scope="text">
        <img style="width: 110px; height: 60px" :src="text" alt="" />
      </template>
      <a-avatar slot="avatar" icon="user" />
      <span slot="memberStatus" slot-scope="text, record">
        <a-switch
          checked-children="开启"
          un-checked-children="未开启"
          :checked="record.status === 1 ? true : false"
          @change="onChanges(record)"
        />
      </span>
      <template slot="operate" slot-scope="text, operate">
        <a
          href=""
          v-on:click.prevent="
            topage(`/home/partManagement/EditpartManagement?id=${operate.id}`)
          "
          >编辑</a
        >
        <a @click="del(operate)">删除</a>
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  partManagementListTwo,
  partManagementListDisable,
  partManagementListTwoDel,
  partManagementListDels,
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "角色编号",
    dataIndex: "id",
    sorter: true,
    scopedSlots: { customRender: "id" },
  },
  {
    title: "角色名称",
    dataIndex: "roleName",
  },
  {
    title: "角色描述",
    dataIndex: "roleDesc",
  },
  {
    title: "状态",
    dataIndex: "status",
    sorter: true,
    scopedSlots: { customRender: "memberStatus" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    sorter: true,
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    width: 200,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getPartManagementListTwo();
  },
  props: ["formInline"],
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.$store.commit("setroleList", selectedRowKeys);
          console.log(`selectedRowKeys: ${selectedRowKeys}`);
        },
      };
    },
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    // 分页按钮
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      partManagementListTwo({ limit: 10, page: this.pagination.current }).then(
        (res) => {
          this.data = res.data;
          console.log(res);
        }
      );
      this.loading = false;
    },
    getPartManagementListTwo() {
      partManagementListTwo({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    del(row) {
      this.loading = true;
      partManagementListTwoDel(row.id).then((res) => {
        this.loading = false;
        this.getPartManagementListTwo();
        message.success(res.data);
      });
    },
    dels() {
      let roleList = this.$store.state.roleList;
      partManagementListDels(roleList).then((res) => {
        this.getPartManagementListTwo();
        message.success(res.data);
      });
    },
    query() {
      this.loading = true;
      partManagementListTwo(this.formInline).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    onChanges(row) {
      console.log(row);
      if (row.status === 1) {
        partManagementListDisable(row.id, 0).then(() => {
          this.getPartManagementListTwo();
          message.success(res.data);
        });
      }
      if (row.status === 0) {
        partManagementListDisable(row.id, 1).then(() => {
          this.getPartManagementListTwo();
          message.success(res.data);
        });
      }
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/right/partManagement/partManagementHomeContent.vue